import { render, staticRenderFns } from "./bgmusic.vue?vue&type=template&id=76e866e6&scoped=true"
import script from "./bgmusic.vue?vue&type=script&lang=js"
export * from "./bgmusic.vue?vue&type=script&lang=js"
import style0 from "./bgmusic.vue?vue&type=style&index=0&id=76e866e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e866e6",
  null
  
)

export default component.exports